import * as _v3 from "v8";

var _v2 = "default" in _v3 ? _v3.default : _v3;

import { dew as _cloneDeepBrowser2Dew } from "./clone-deep-browser";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = _default;

  function _v() {
    const data = _v2;

    _v = function () {
      return data;
    };

    return data;
  }

  var _cloneDeepBrowser = _cloneDeepBrowser2Dew();

  function _default(value) {
    if (_v().deserialize && _v().serialize) {
      return _v().deserialize(_v().serialize(value));
    }

    return (0, _cloneDeepBrowser.default)(value);
  }

  return exports;
}